<template>
    <div class="report_data" :style="{ height: props.reportDataHeight, margin: props.reportDataMargin }">
        <div class="scroll_wrapper">
            <div class="scroll_content">
                <!-- Original list -->
                <div class="scroll_list">
                    <van-row v-for="(item, index) in props.dataList" :key="`a-${index}`">
                        <van-col span="8" :style="{ padding: props.colPadding }">{{ maskPhone(item.phone) }}</van-col>
                        <van-col span="10" :style="{ padding: props.colPadding }">{{ item.content }}</van-col>
                        <van-col span="6" class="currency_col" :style="{ padding: props.colPadding }">
                            <div v-if="!isReverse" class="currency_content">
                                <div class="currency" :style="{ fontSize: props.currencyTextSize }">R$</div>
                                <span :style="{ fontSize: props.currencySpanTextSize }">+{{ item.coin / 100 }}</span>
                            </div>
                            <div v-else class="currency_content">
                                <span :style="{ fontSize: props.currencySpanTextSize }">+{{ item.coin / 100 }}</span>
                                <div class="currency" :style="{ fontSize: props.currencyTextSize }">R$</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <!-- Duplicate list for seamless loop -->
                <div class="scroll_list">
                    <van-row v-for="(item, index) in props.dataList" :key="`b-${index}`">
                        <van-col span="8" :style="{ padding: props.colPadding }">{{ maskPhone(item.phone) }}</van-col>
                        <van-col span="10" :style="{ padding: props.colPadding }">{{ item.content }}</van-col>
                        <van-col span="6" class="currency_col" :style="{ padding: props.colPadding }">
                            <div v-if="!isReverse" class="currency_content">
                                <div class="currency" :style="{ fontSize: props.currencyTextSize }">R$</div>
                                <span :style="{ fontSize: props.currencySpanTextSize }">+{{ item.coin / 100 }}</span>
                            </div>
                            <div v-else class="currency_content">
                                <span :style="{ fontSize: props.currencySpanTextSize }">+{{ item.coin / 100 }}</span>
                                <div class="currency" :style="{ fontSize: props.currencyTextSize }">R$</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { PropType } from 'vue'
interface AssistList {
    phone: string,
    content: string,
    coin: number,
}
const props = defineProps({
    dataList: {
        type: Array as PropType<AssistList[]>,
    },
    reportDataHeight: {
        type: String,
        default: '195px'
    },
    reportDataMargin: {
        type: String,
        default: '0 25px'
    },
    colPadding: {
        type: String,
        default: '10px'
    },
    currencyTextSize: {
        type: String,
        default: '12px'
    },
    currencySpanTextSize: {
        type: String,
        default: '14px'
    },
    isReverse: {
        type: Boolean,
        default: false
    }

})
const maskPhone = (phone: string) => {
    if (!phone || phone.length < 6) return phone;
    return phone.slice(0, 3) + '*******' + phone.slice(-3);
}
</script>
<style scoped>
.report_data {
    overflow: hidden;
    margin: 0 25px;
    padding: 0 10px;
    color: rgba(255, 255, 255, 0.65);
}

.scroll_wrapper {
    height: 100%;
    overflow: hidden;
    position: relative;
}

.scroll_content {
    display: flex;
    flex-direction: column;
    animation: scroll-up 10s linear infinite;
}

.scroll_list {
    display: flex;
    flex-direction: column;
}

.scroll_list>>>.van-col {
    display: flex;
    justify-content: center;
    align-items: center;
}

.currency {
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: bold;
    padding: 5px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    margin: 0 2px;
}

.currency_col span {
    color: #F0A853;
    font-size: 14px;
}

.currency_content {
    display: flex;
    flex-direction: row;
    align-items: center;
}

@keyframes scroll-up {
    0% {
        transform: translateY(0%);
    }

    100% {
        transform: translateY(-50%);
    }
}
</style>